import MigrationPending from '@/components/ui/MigrationPending'

export default function PalletsIndex() {
  return <MigrationPending title="Pallets" subtitle="Pallets list — migration to new stack pending" />
}

PalletsIndex.layout = MigrationPending.layout
